import {createSlice} from "@reduxjs/toolkit"
import { add } from "date-fns"


const InitialState = {
    vendor:[]
}

export const vendorsSlice = createSlice({
    name:"vendors",
    initialState:InitialState,
    reducers:{
        addAllVendors:(state,action)=>{
            state.vendor = action.payload
        },
        addVendor:(state,action)=>{
            state.vendor.push(action.payload)
        },
        updateVendor: (state, action) => {
  const updatedVendor = action.payload;
  const vendorIndex = state.vendor.findIndex(vendor => vendor._id === updatedVendor._id);
  if (vendorIndex !== -1) {
    state.vendor[vendorIndex] = {
      ...state.vendor[vendorIndex],
      ...updatedVendor
    };
  }
}
    }
})



export const {addAllVendors,addVendor,updateVendor} = vendorsSlice.actions

export default vendorsSlice.reducer